import React from "react";
import CampaignsContainer from "../containers/CampaignsContainer";

export const CampaignsPage: React.FunctionComponent = () => <CampaignsContainer />;